// extracted by mini-css-extract-plugin
export var table = "K_c";